import { render } from "./UpdateProfileForm.vue?vue&type=template&id=607dfcf5&scoped=true"
import script from "./UpdateProfileForm.vue?vue&type=script&lang=js"
export * from "./UpdateProfileForm.vue?vue&type=script&lang=js"

import "./UpdateProfileForm.vue?vue&type=style&index=0&id=607dfcf5&scoped=true&lang=css"
import "./UpdateProfileForm.vue?vue&type=style&index=1&id=607dfcf5&lang=css"

import exportComponent from "../../../../../Users/matteocoffin/Documents/ecommerce-ouicsport copie 4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607dfcf5"]])

export default __exports__